<template>
  <EditableList
    ref="list"
    :list="options"
    :pending="pending"
    :form-add-title="$t('shop.addProduct')"
    :form-edit-title="$t('shop.editProduct')"
    @submit="$refs.form.submit()"
    @remove="$refs.form.remove()"
    @selected="selected = $event"
  >
    <template #list="{ list, toggle }">
      <div style="min-height: 500px">
        <SubCatalogsList
          class="pl-4"
          :list="list"
          :toggle="toggle"
          :selected="selected"
          :root-id="''"
          @orderUpdated="updateNodeOrder"
        />
        <div
          v-if="orderSaved"
          class="text-success mt-2 small text-center"
        >
          {{ $t('shop.orderChangeSaved') }}
        </div>
      </div>
    </template>

    <template #form="{edited}">
      <ProductForm
        ref="form"
        :product="getProduct(edited)"
        :catalog-id="catalogId"
        :pending.sync="pending"
        @close="$refs.list.close()"
        @refresh="$emit('refresh')"
      />
    </template>
  </EditableList>
</template>

<script>
import EditableList from '@/components/settings/EditableList';
import ProductForm from '@/components/shop/ProductForm';
import { mapActions, mapGetters } from 'vuex';
import SubCatalogsList from './SubCatalogsList';

export default {
  props: {
    catalogId: String,
  },
  data: () => ({
    selected: null,
    pending: false,
    orderSaved: false,
  }),
  components: {
    EditableList,
    SubCatalogsList,
    ProductForm,
  },
  computed: {
    ...mapGetters('shop', ['products']),
    options() {
      return this.products.map((x) => ({
        id: x.id,
        name: x.name,
        parentCode: '',
        ordinal: x.ordinal,
      }));
    },
  },
  methods: {
    ...mapActions('shop', ['setProductsOrder']),
    getProduct(id) {
      return this.products.find((x) => x.id === id);
    },
    updateNodeOrder({ order }) {
      const sorted = Object.keys(order).sort((a, b) => order[a] - order[b]);

      this.setProductsOrder({
        params: {
          catalogId: this.catalogId,
        },
        data: {
          order: sorted,
        },
      })
        .then(() => {
          this.orderSaved = true;
        });
    },
  },
};
</script>
